import React, { useMemo } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

function BarChartComponent({ datasets, labels, title }) {
    const options = {
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                text: title,
                position: "top",
                font: { size: 20 },
            },
            legend: {
                display: true,
                position: "bottom",
                labels: {
                    color: "black",
                    padding: 30,
                },
            },
            tooltip: {
                mode: "nearest",
                intersect: true,
                callbacks: {
                    label: (tooltipItem) => {
                        const { dataset, dataIndex } = tooltipItem;
                        const originalValue = dataset.originalData[dataIndex]; // Lấy số nguyên gốc
                        return `${dataset.label}: ${originalValue}`;
                    },
                    title: (tooltipItems) => {
                        return tooltipItems[0].dataset.stack;
                    },
                }
            },
            datalabels: {
                color: "black",
                font: { weight: 'bold' },
                formatter: (value, context) => {
                    return context.dataset.originalData[context.dataIndex];
                }
            },
        },
        responsive: true,
        interaction: {
            mode: "index",
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                min: 0,
                max: 110,
                ticks: {
                    callback: function (value) {
                        return value > 100 ? "" : value;
                    }
                }
            },
        },
    };

    const sum_stake_bar = useMemo(()=>{
        if (!datasets.length) return [];
        const result = [];
        for (var i = 0; i < datasets[0].data.length; i++) {
            const sum = {};
            for (var item of datasets) {
                if (!(item.stack in sum)) {
                    sum[item.stack] = 0
                }
                sum[item.stack] += item.data[i];
            }
            result.push(sum);
        }
        return result;
    }, [datasets])

    const data = {
        labels,
        datasets: datasets.map(bar => ({
            ...bar,
            originalData: [...bar.data],
            data: bar.data.map((num, index) =>
                sum_stake_bar[index][bar.stack] 
                    ? Math.floor((num / sum_stake_bar[index][bar.stack]) * 1000) / 10
                    : 0
            )
        }))
    };
    return (
        <div style={{ minHeight: "500px", minWidth: 800 }}>
            <Bar options={options} data={data} />
        </div>
    );
}

const BarChart = React.memo(BarChartComponent);

export default BarChart;